var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "td",
    {
      staticClass: "cell",
      style: _vm.computed_style,
      attrs: { tabindex: "0" },
      on: { click: _vm.edit_cell, focus: _vm.edit_cell }
    },
    [
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.is_editing,
              expression: "!is_editing"
            }
          ],
          staticClass: "display-span"
        },
        [_vm._v(_vm._s(_vm.display_value))]
      ),
      _vm._v(" "),
      _vm.is_editing
        ? _c("input", {
            directives: [
              { name: "focus", rawName: "v-focus" },
              {
                name: "model",
                rawName: "v-model",
                value: _vm.temp_value,
                expression: "temp_value"
              }
            ],
            ref: "input",
            staticClass: "edit-input",
            style: _vm.computed_input_style,
            attrs: { type: "text" },
            domProps: { value: _vm.temp_value },
            on: {
              blur: _vm.commit_edit,
              keydown: _vm.on_keydown,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.temp_value = $event.target.value
              }
            }
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bd7525d", { render: render, staticRenderFns: staticRenderFns })
  }
}